import {getRealmNameNext} from "./actionTypes";
import {createHttpAction} from "../Next/http-fetch";

export const getRealmNameOnInitialization = (onSuccess) => createHttpAction(getRealmNameNext, null, {onSuccess}).action;

export const appGetWhitelabelInfo = (onSuccess) => createHttpAction(getRealmNameNext, null, {onSuccess}).action;
